// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Dlsw","col":"styles_col__2gYdx"};